module.exports = __webpack_public_path__ + "static/media/yyc-data-logo.0d1a1acd.svg";